import axios from '../../api/axios';

export const state = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSidebarType: 'light',
  topbar: 'light',
  loader: false,
  mode: "light",
  sideMenu: {},
  subitems: {},
  folderId: null,
  stampId: null,
  currentFilter: null,
  deleteSideMenu: {},
  countryFilter: null,
  hasActiveFilters: false,
  filteredCounts: {}, // Store filtered counts by folder ID
  folderCounts: {},
  printSidebar: false,
};

export const getters = {
  subitems: state => state.subitems,
};

export const mutations = {
  SET_FILTERED_COUNT(state, { folderId, count }) {
    state.filteredCounts = {
      ...state.filteredCounts,
      [folderId]: count
    };
  },
  // CHANGE_LAYOUT(state, layoutType) {
  //   state.layoutType = layoutType;
  // },
  // CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
  //   state.layoutWidth = layoutWidth;
  // },
  // CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
  //   state.leftSidebarType = leftSidebarType;
  // },
  // CHANGE_TOPBAR(state, topbar) {
  //   state.topbar = topbar;
  // },
  // LOADER(state, loader) {
  //   state.loader = loader;
  // },
  // CHANGE_MODE(state, mode) {
  //   state.mode = mode;
  // },
  CHANGE_SIDE_MENU(state, sideMenu) {
    state.sideMenu = sideMenu;
   },
  SET_SUBITEMS_DATA(state, subitems) {
    state.subitems = subitems;
  },
  SET_FOLDERID(state, folderId) {
    state.folderId = folderId;
  },
  SET_STAMPID(state, stampId) {
    state.stampId = stampId;
  },
  SET_CURRENT_FILTER(state, filter) {
    state.currentFilter = filter;
  },
   DELETE_FOLDER_SIDE_MENU(state, deleteSideMenu) {
    state.deleteSideMenu = deleteSideMenu;
  },
  SET_COUNTRY_FILTER(state, payload) {
    state.countryFilter = payload;
  },
  SET_PRINT_SIDEBAR(state, printSidebar) {
    state.printSidebar = printSidebar;
  },
  SET_HAS_ACTIVE_FILTERS(state, val) {
    state.hasActiveFilters = !!val;
  },
    SET_FOLDER_COUNT(state, { folderId, count }) {
    const key = String(folderId);

    if (count === null || count === undefined) {
      const next = { ...state.folderCounts };
      delete next[key];
      state.folderCounts = next;
      return;
    }

    state.folderCounts = {
      ...state.folderCounts,
      [key]: Number(count) || 0
    };
  },

};

export const actions = {
  // changeLayoutType({ commit }, { layoutType }) {
  //   commit('CHANGE_LAYOUT', layoutType);
  // },
  // changeLayoutWidth({ commit }, { layoutWidth }) {
  //   commit('CHANGE_LAYOUT_WIDTH', layoutWidth);
  // },
  // changeLeftSidebarType({ commit }, { leftSidebarType }) {
  //   commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType);
  // },
  // changeTopbar({ commit }, { topbar }) {
  //   commit('CHANGE_TOPBAR', topbar);
  // },
  // changeLoaderValue({ commit }, { loader }) {
  //   commit('LOADER', loader);
  // },
  // changeLayoutMode({ commit }, { mode }) {
  //   commit("CHANGE_MODE", mode);
  // },
  redirectFolderId({ commit }, { folderId }) {
    commit("SET_FOLDERID", folderId);
  },
  stampId({ commit }, { stampId }) {
    commit("SET_STAMPID", stampId);
  },
  countryFilter({ commit }, { countryFilter }) {
    return new Promise((resolve) => {
      commit("SET_COUNTRY_FILTER", countryFilter);

      if (countryFilter) {
        localStorage.setItem('countryFilter', countryFilter);
      } else {
        localStorage.removeItem('countryFilter');
      }
      resolve();
    });
  },
  requestSidebarPrint({ commit }) {
    commit('SET_PRINT_SIDEBAR', true);
  },
  updateFilteredCount({ commit }, { folderId, count }) {
    commit('SET_FILTERED_COUNT', { folderId, count });
  },
  updateFolderCount({ commit }, { folderId, count }) {
    commit("SET_FOLDER_COUNT", { folderId, count });
  },
  async setSideMenu({ commit }, payload) {
    try {
      commit("SET_CURRENT_FILTER", payload);

      const response = await axios.get(process.env.VUE_APP_URL + 'api/folder/get-all',
        {
          params: payload
        }
      );

      commit("CHANGE_SIDE_MENU", response.data.result);
      return response;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  async setDeletedSideMenu({ commit }, payload) {
    try {
      commit("SET_CURRENT_FILTER", payload);
      

      const response = await axios.get(process.env.VUE_APP_URL + 'api/folder/get-all',{
        params: {
          ...payload,
          is_deleted: true,  // <-- put it inside params
        }
      });

      console.log("response",response);

      commit("DELETE_FOLDER_SIDE_MENU", response.data.result);
      return response;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  async fetchSubitemsData({ commit }, { requestData }) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_STAMPBOX_BACKEND_URL}api/dataportal/create-stamp`, requestData);
      commit('SET_SUBITEMS_DATA', response.data.result.stamp_item);
      return response;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  },
};
